import React, { useState, useRef, useEffect } from "react";
import {
  dotNumberBlurValidation,
  dotNumberValidation,
  makeAjax,
  respStatus,
  showMessage,
  url,
  withDotValidation,
} from "../../../../helpers/global_helper";
import { useSelector, useDispatch } from "react-redux";
import { formatPrice } from "../../../NumberFormat";
import { withTranslation } from "react-i18next";
import ErrorInnerPopup from "../../../Popups/ErrorInnerPopup";
import ErrorPopup from "../../../Popups/ErrorPopup";
import BetSuccessPopup from "../../../Popups/BetSuccessPopup";
import ConfirmBetDeskonPopup from "../../../Popups/ConfirmBetDeskonPopup";
import CancelledBetDeskonPopup from "../../../Popups/CancelledBetDeskonPopup";
import { getUserBalance, setCommonConfig } from "../../../../redux/actions";
import GameClosedPopup from "../GameClosedPopup";
import MarketClose from "../MarketClose";
import CommonBetHeader from "../CommonBetHeader";

const ColokNaga = (props) => {
  const dispatch = useDispatch();
  const device = useSelector((state) => state.CommonConfig.device_type);
  const [rowsToShow, setRowsToShow] = useState(10);
  const [betValues, setBetValues] = useState(Array(rowsToShow).fill(""));
  const [betsEnabled, setBetsEnabled] = useState(Array(rowsToShow).fill(false));
  const [bets, setBets] = useState({});
  const [belli, setBbelli] = useState({});
  const [diskon, setDiskon] = useState({});
  const [bolakBalik, setBolakBalik] = useState({});
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [focusIndex, setFocusIndex] = useState(null);
  const beliRefs = useRef(Array(rowsToShow).fill(null));
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [totalBet, setTotalBet] = useState(0);
  const [headerInputValue, setHeaderInputValue] = useState("");
  const [autobetValue, setAutobetValue] = useState("");

  const [reqData, setReqData] = useState({
    isfullbet: null,
    gameId: null,
    gameType: "coloknaga",
    action: "process",
    betTogelAuth: "betTogelAuth",
    allowPartner: "allowPartner",
    dataangka: [],
  });

  const [inputValues, setInputValues] = useState({});

  const [invalidRows, setInvalidRows] = useState([]);

  const [showErrorPopup, setShowErrorPopup] = useState(false);

  const [errorMessages, setErrorMessages] = useState([]);

  const inputRefs = useRef({});

  const [highlightRow, setHighlightRow] = useState(false);

  const [successPopup, setSuccessPopup] = useState(false);

  const [respData, setRespData] = useState([]);

  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);

  const [succMessage, setSuccessMessage] = useState("");
  const [totalBetAmount, setTotalBetAmount] = useState(0);
  const [bbPayAmount, setBBPayAmount] = useState(0);

  let dicountValue = 1000;

  const handleAutoBet = (e) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (value > betDiscount.showMax / 1000) {
      setErrorMessages(props.t("you_have_reached_max_bet_value"));
      setShowErrorPopup(true);
      return;
    }

    if (regex.test(value)) {
      setAutobetValue(value);
    }
  }

  const handleAutoBetBlur = (e) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setAutobetValue(value);
    }
  }

  const handleFocusInput = (e, rowIndex, columnName) => {
    if (e.target.value == '') {
      const updatedInputValues = { ...inputValues };
      Object.keys(updatedInputValues).forEach((index) => {
        const row = updatedInputValues[index];

        if (row.number1 && row.number2 && row.number3 && !row.buy && autobetValue) {
          updatedInputValues[index]["buy"] = autobetValue;
          calculateDiscount(autobetValue, index); // Pass index as rowIndex
        }
      });

      setInputValues(updatedInputValues);

      const newInputValues = { ...inputValues };

      // Validation
      const rowValues = newInputValues[rowIndex];
      const isRowComplete =
        rowValues.number1 &&
        rowValues.number2 &&
        rowValues.number3 &&
        rowValues.buy;

      const newInvalidRows = [...invalidRows];

      if (columnName === "buy") {
        newInputValues[rowIndex]["buy"] = autobetValue;
        if (autobetValue === "") {
          newInputValues[rowIndex]["discount"] = "";
          newInputValues[rowIndex]["pay"] = "";
        }
        calculateDiscount(autobetValue, rowIndex);
      } else {
        newInputValues[rowIndex][columnName] = autobetValue;
      }

      if (!isRowComplete) {
        if (!newInvalidRows.includes(rowIndex)) {
          newInvalidRows.push(rowIndex);
        }
      } else {
        const index = newInvalidRows.indexOf(rowIndex);
        if (index > -1) {
          newInvalidRows.splice(index, 1);
        }
      }
      setInputValues(newInputValues);

      setInvalidRows(newInvalidRows);

      const dataangka = Object.keys(newInputValues).reduce((acc, key) => {
        const row = newInputValues[key];
        if (row.buy) {
          acc.push([row.number1 + row.number2 + row.number3, row.buy * 1000]);
        }
        return acc;
      }, []);

      setReqData({
        ...reqData,
        dataangka: dataangka,
        gameId: gameId,
      });
    }
  }

  const handleInputBlur = (e, rowIndex, columnName) => {
    let { name, value } = e.target;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    e.target.value = value;
    handleInputChange(e, rowIndex, columnName);
  }

  const handleInputChange = (e, rowIndex, columnName) => {
    let value = '';

    value = e.target.value;

    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      if (columnName === 'buy') {
        regex = /^\d*$/;
        value = withDotValidation(value);
      } else {
        regex = /^[0-9]*$/;
      }
    }

    if (!regex.test(value)) {
      value = value.toString().slice(0, -1);
    }

    setHighlightRow(false);

    setErrorMessages([]);

    setShowErrorPopup(false);


    if (columnName === 'buy' && value < 0) {
      value = '';
      return;
    }

    if (isNaN(value)) {
      value = ""; // Reset to empty value if not an integer
      return;
    }

    if (!value) {
      calculateDiscount(0, rowIndex);
    }

    if (
      columnName === "buy" &&
      betDiscount &&
      value > betDiscount.showMax / 1000
    ) {
      setErrorMessages(props.t("you_have_reached_max_bet_value"));
      setShowErrorPopup(true);
      return;
    }
    const newInputValues = { ...inputValues };

    if (!newInputValues[rowIndex]) {
      newInputValues[rowIndex] = {
        number1: "",
        number2: "",
        number3: "",
        buy: "",
      };
    }

    if (columnName === "number1" && value.length > 1) {
      newInputValues[rowIndex]["number2"] = value.slice(-1);

      value = value[1];

      columnName = "number2";

      setTimeout(() => {
        inputRefs.current[`${rowIndex}-number2`].focus();
      }, 0);
    } else if (columnName === "number2" && value.length > 1) {
      newInputValues[rowIndex]["number3"] += value.slice(1);

      value = value[1];

      columnName = "number3";

      setTimeout(() => {
        inputRefs.current[`${rowIndex}-number3`].focus();
      }, 0);
    } else if (columnName === "number3" && value.length > 1 && newInputValues[rowIndex]["number1"] && newInputValues[rowIndex]["number2"]) {
      newInputValues[rowIndex]["buy"] += value.slice(1);
      if (String(betDiscount.showMin).length === 3) {
        value[1] >= 0 ? (value = value[1]) : (value = "");
      } else {
        value[1] > 0 ? (value = value[1]) : (value = "");
      }
      columnName = "buy";
      setTimeout(() => {
        inputRefs.current[`${rowIndex}-buy`].focus();
      }, 0);
    } else if (
      (columnName === "number1" &&
        newInputValues[rowIndex]["number1"] &&
        newInputValues[rowIndex]["number1"] == value) ||
      (columnName === "number2" &&
        newInputValues[rowIndex]["number2"] &&
        newInputValues[rowIndex]["number2"] == value) ||
      (columnName === "number3" &&
        newInputValues[rowIndex]["number3"] &&
        newInputValues[rowIndex]["number3"] == value)
    ) {
      return;
    }
    if (columnName === "number3" && value.length > 1) {
      return;
    }
    newInputValues[rowIndex][columnName] = value;

    // Clear the "buy" field if any of the guess fields are empty
    if (
      columnName !== "buy" &&
      (!newInputValues[rowIndex]["number1"] ||
        !newInputValues[rowIndex]["number2"] ||
        !newInputValues[rowIndex]["number3"])
    ) {
      newInputValues[rowIndex]["buy"] = "";
      // calculateDiscount(0, rowIndex);

    }


    // Validation
    const rowValues = newInputValues[rowIndex];

    const isRowComplete =
      rowValues.number1 &&
      rowValues.number2 &&
      rowValues.number3 &&
      rowValues.buy;

    const newInvalidRows = [...invalidRows];

    if (
      (rowValues.number1 && rowValues.number1 === rowValues.number2) ||
      (rowValues.number1 && rowValues.number1 === rowValues.number3) ||
      (rowValues.number2 && rowValues.number2 === rowValues.number3)
    ) {
      setErrorMessages(props.t("guess_number_should_not_be_the_same"));

      setShowErrorPopup(true);

      value = "";

      newInputValues[rowIndex][columnName] = value;

      if (!newInvalidRows.includes(rowIndex)) {
        newInvalidRows.push(rowIndex);
      }
    } else {
      const index = invalidRows.indexOf(rowIndex);
      if (index > -1) {
        invalidRows.splice(index, 1);
      }
    }

    if ((columnName == "number3" || columnName == "number1" || columnName == "number2") && newInputValues[rowIndex]["number1"] && newInputValues[rowIndex]["number2"] && newInputValues[rowIndex]["number3"]) {
      let buyValue;
      if (autobetValue) {
        newInputValues[rowIndex]["buy"] = autobetValue;
        buyValue = autobetValue;
      } else {
        buyValue = newInputValues[rowIndex]["buy"];
      }
      if (buyValue) {
        calculateDiscount(buyValue, rowIndex);
      }
    }

    if (columnName === "buy") {
      newInputValues[rowIndex]["buy"] = value;
      if (value === "") {
        newInputValues[rowIndex]["discount"] = "";
        newInputValues[rowIndex]["pay"] = "";
      }
      calculateDiscount(value, rowIndex);
    } else {
      newInputValues[rowIndex][columnName] = value;
    }

    if (!isRowComplete) {
      if (!newInvalidRows.includes(rowIndex)) {
        newInvalidRows.push(rowIndex);
      }
    } else {
      const index = newInvalidRows.indexOf(rowIndex);
      if (index > -1) {
        newInvalidRows.splice(index, 1);
      }
    }
    setInputValues(newInputValues);

    setInvalidRows(newInvalidRows);

    const dataangka = Object.keys(newInputValues).map((key) => {
      const row = newInputValues[key];
      return [row.number1 + row.number2 + row.number3, row.buy * betDiscount.showMultiple]; // Adjust this based on your needs
    });

    setReqData({
      ...reqData,
      dataangka: dataangka,
      gameId: gameId,
    });
  };

  useEffect(() => {
    const updatedInputValues = { ...inputValues };
    Object.keys(updatedInputValues).forEach((index) => {
      const row = updatedInputValues[index];

      // if (row.number1 && row.number2 && row.number3 && !row.buy && autobetValue) {
      //   updatedInputValues[index]["buy"] = autobetValue;
      //   calculateDiscount(autobetValue, index); // Pass index as rowIndex
      // }
    });

    setInputValues(updatedInputValues); // Update inputValues state
  }, [autobetValue]);


  const calculateDiscount = (buyValue, rowIndex) => {
    const baseValue = buyValue * betDiscount.showMultiple;
    const discount = betDiscount.showDisc ? (baseValue * betDiscount.showDisc) / 100 : 0;
    const finalAmount = baseValue - discount;

    let newInputValues = { ...inputValues };

    if (buyValue === 0) {
      newInputValues[rowIndex]["discount"] = 0;
      newInputValues[rowIndex]["pay"] = 0;
      setInputValues(newInputValues);

      updateTotalPayAmount(newInputValues);
    } else {

      newInputValues[rowIndex]["discount"] = discount;
      newInputValues[rowIndex]["pay"] = finalAmount;

      setInputValues(newInputValues);

      updateTotalPayAmount(newInputValues);
    }

  };


  const updateTotalPayAmount = (updatedInputValues) => {

    const total = Object.keys(updatedInputValues).reduce((sum, key) => {
      const row = updatedInputValues[key];
      return sum + (row.pay || 0);
    }, 0);

    setTotalBetAmount(total);
  };

  useEffect(() => {
  }, [totalBetAmount]);

  const invalidStyle = {
    border: "2px solid red",
    backgroundColor: "#ffe6e6",
  };

  useEffect(() => {
    const dataangka = Object.keys(bets)
      .filter((index) => {
        const isBetsFilled = bets[index]?.every((digit) => digit !== "");
        return isBetsFilled && belli[index];
      })
      .map((index) => {
        const combinedNumber = bets[index].join("");
        return [combinedNumber, parseInt(belli[index]) * betDiscount.showMultiple, "success"];
      });

    setReqData({
      ...reqData,
      dataangka: dataangka,
      gameId: gameId,
    });
  }, [bets, belli]);
  const confirmBet = () => {
    const hasZeroBuy = reqData.dataangka.some((entry) => entry[1] === 0);
    if (reqData.dataangka.length < 1) {
      setErrorMessages(props.t("guess_bet_wrong"));
      setShowErrorPopup(true);
    } else {
      setSuccessMessage("");
      setShowConfirmationPopup(true);
    }
  };
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }

  };
  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    reqData.dataangka = reqData.dataangka.filter((entry) => entry[1] !== 0);

    makeAjax(url.TOGEL_API.processAltTogel, reqData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          setErrorMessages(props.t(response.code));
          setShowErrorPopup(true);
          return;
        }
        setReqData({
          isfullbet: null,
          gameId: null,
          gameType: "coloknaga",
          action: "process",
          betTogelAuth: "betTogelAuth",
          allowPartner: "allowPartner",
          dataangka: [],
        });
        showMessage(response);
        return;
      }
      setRespData((prevArray) => [...prevArray, response.data]);
      dispatch(getUserBalance());
      setSuccessPopup(true);
      // setShowConfirmationPopup(false);
      resetBetData();
    });
  };

  useEffect(() => {
    resetBetData();
  }, [gameId]);

  const resetBetData = () => {
    setInputValues({});

    setInvalidRows([]);

    setShowErrorPopup(false);

    setErrorMessages([]);

    setHighlightRow(false);

    setReqData({
      isfullbet: null,
      gameId: null,
      gameType: "coloknaga",
      action: "process",
      betTogelAuth: "betTogelAuth",
      allowPartner: "allowPartner",
      dataangka: [],
    });
    setErrorMessages([]);
    setBetValues(Array(rowsToShow).fill(""));
    setBetsEnabled(Array(rowsToShow).fill(false));
    setShowErrorPopup(false);
    setBbelli([]);
    setBets("");
    setDiskon("");
    setBolakBalik("");
    setTotalBet(0);
    setHeaderInputValue("");
    setAutobetValue("");
    setTotalBetAmount(0)
  };
  const rowDataReset = (rowIndex) => {
    setBets((prev) => {
      const updated = { ...prev };
      delete updated[rowIndex];
      return updated;
    });
    setBbelli((prev) => {
      const updated = { ...prev };
      delete updated[rowIndex];
      return updated;
    });

    setDiskon((prev) => {
      const updated = { ...prev };
      delete updated[rowIndex];
      return updated;
    });

    setBolakBalik((prev) => {
      const updated = { ...prev };
      delete updated[rowIndex];
      return updated;
    });
    setBetsEnabled((prevEnabled) => {
      const newEnabled = [...prevEnabled];
      newEnabled[rowIndex] = false;
      return newEnabled;
    });
  };
  const handleClose = () => {
    setRespData([]);
    setSuccessPopup(false);
  };
  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
  };
  useEffect(() => {
    if (focusIndex !== null) {
      beliRefs.current[focusIndex].focus();
      setFocusIndex(null);
    }
  }, [focusIndex, betsEnabled]);
  return (
    <div className="coloknaga_wrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          <CommonBetHeader
            gameName="colokNaga"
            rowsToShow={null}
            handleRowsToShowChange={null}
            bbPayAmount={bbPayAmount}
            totalBetAmount={totalBetAmount}
            changeText={"Silang Homo"}
          />
          <div className="coloknaga_container">
            <table>
              <thead>
                <tr className="Heading">
                  <th>{props.t("no.")}</th>
                  {/* <th>{props.t("guess")}1</th>
                    <th>{props.t("guess")}2</th>
                    <th>{props.t("guess")}3</th> */}
                  <th>{props.t("number")} 1</th>
                  <th>{props.t("number")} 2</th>
                  <th>{props.t("number")} 3</th>
                  <th><input type="text" placeholder="Auto Bet" value={autobetValue} onChange={handleAutoBet} onBlur={handleAutoBetBlur} inputMode="decimal" pattern="[0-9]*[.,]?[0-9]**" /></th>
                  {/* <th style={{ width: device === "Mobile" ? null : "250px" }}>{props.t("bet")} (x1000)</th> */}
                  {device === "Desktop" && (
                    <>
                      <th>{props.t("discount")}</th>
                      <th>{props.t("pay")}</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {[...Array(rowsToShow)].map((_, index) => {
                  const isPreviousRowComplete =
                    index === 0 ||
                    (inputValues[index - 1] &&
                      inputValues[index - 1].number1 &&
                      inputValues[index - 1].number2 &&
                      inputValues[index - 1].number3 &&
                      inputValues[index - 1].buy);

                  return (
                    <tr
                      key={index}
                      className={index % 2 === 0 ? "even-row" : "odd-row"}
                    >
                      <td>{index + 1}</td>
                      <td className="inputs">
                        <input
                          type="text"
                          value={inputValues[index]?.number1 || ""}
                          onChange={(e) =>
                            handleInputChange(e, index, "number1")
                          }
                          style={
                            invalidRows.includes(index) &&
                              highlightRow &&
                              !inputValues[index]?.number1
                              ? invalidStyle
                              : {}
                          }
                        // disabled={!isPreviousRowComplete}
                        />
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          value={inputValues[index]?.number2 || ""}
                          onChange={(e) =>
                            handleInputChange(e, index, "number2")
                          }
                          style={
                            invalidRows.includes(index) &&
                              highlightRow &&
                              !inputValues[index]?.number2
                              ? invalidStyle
                              : {}
                          }
                          // disabled={!isPreviousRowComplete}
                          // disabled={!inputValues[index]?.number1}
                          ref={(el) =>
                            (inputRefs.current[`${index}-number2`] = el)
                          }
                        />
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          value={inputValues[index]?.number3 || ""}
                          onChange={(e) =>
                            handleInputChange(e, index, "number3")
                          }
                          style={
                            invalidRows.includes(index) &&
                              highlightRow &&
                              !inputValues[index]?.number3
                              ? invalidStyle
                              : {}
                          }
                          // disabled={!isPreviousRowComplete}
                          // disabled={!inputValues[index]?.number2}
                          ref={(el) =>
                            (inputRefs.current[`${index}-number3`] = el)
                          }
                        />
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          placeholder="Bet"
                          value={inputValues[index]?.buy || ""}
                          onChange={(e) => handleInputChange(e, index, "buy")}
                          onFocus={(e) => handleFocusInput(e, index, "buy")}
                          onBlur={(e) => handleInputBlur(e, index, "buy")}
                          className={
                            invalidRows.includes(index) &&
                              highlightRow &&
                              !inputValues[index]?.buy
                              ? "invalidStyle"
                              : "validStyle"
                          }
                          disabled={
                            !(
                              inputValues[index]?.number1 &&
                              inputValues[index]?.number2 &&
                              inputValues[index]?.number3
                            )
                          }
                          ref={(el) => (inputRefs.current[`${index}-buy`] = el)}
                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]**"
                        />
                      </td>
                      {device === "Desktop" && (
                        <>
                          <td><input type="text" value={inputValues[index]?.number1 &&
                            inputValues[index]?.number2 &&
                            inputValues[index]?.number3 && inputValues[index]?.discount || ''} disabled={
                              !(
                                inputValues[index]?.number1 &&
                                inputValues[index]?.number2 &&
                                inputValues[index]?.number3
                              )
                            } /></td>
                          <td><input type="text" value={inputValues[index]?.number1 &&
                            inputValues[index]?.number2 &&
                            inputValues[index]?.number3 && inputValues[index]?.pay || ''} disabled={
                              !(
                                inputValues[index]?.number1 &&
                                inputValues[index]?.number2 &&
                                inputValues[index]?.number3
                              )
                            } /></td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="last_div">
            <div className="left_div">
              <p>{props.t("guess_three_4d")}</p>
            </div>
            <div className="right_div">
              <ul className="button-list">
                <li>
                  <button className="reset" onClick={resetBetData}>
                    {props.t("reset")}
                  </button>
                </li>
                <li>
                  <button className="submit" onClick={confirmBet}>
                    {props.t("submit")}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}

      {showErrorPopup && (
        <ErrorInnerPopup
          modalTitle={""}
          modalHeader={true}
          onCloseModal={() => setShowErrorPopup(false)}
        >
          <ErrorPopup
            message={errorMessages}
            onClose={() => setShowErrorPopup(false)}
          />
        </ErrorInnerPopup>
      )}

      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={hanldeConfirmationPopupClose}
          message={succMessage}
          submitProcessOk={submitProcessOk}
        />
      )}
      {showCancelledPopup && (
        <CancelledBetDeskonPopup onClose={() => setShowCanclledPopup(false)} />
      )}

      {successPopup && (
        <div className="popup-overlay ">
          <BetSuccessPopup response={respData} onClose={() => handleClose()} />
        </div>
      )}
    </div>
  );
};

export default withTranslation()(ColokNaga);
